'use client'

import { createContext, useCallback, useState } from 'react'

import type { MenuEntry } from '../../types/services/menu'

type MenuState = {
	menus?: MenuEntry[]
}

const INITIAL_STATE: MenuState = {}

type MenuDispatch = (newState: Partial<MenuState>) => void

const initialDispatch: MenuDispatch = () => {
	/* */
}

type MenuProviderProps = {
	readonly children: React.ReactNode
}

export const MenuDataStateContext = createContext<MenuState>(INITIAL_STATE)
export const MenuDataDispatchContext =
	createContext<MenuDispatch>(initialDispatch)

export const MenuDataProvider = ({ children }: MenuProviderProps) => {
	const [state, setState] = useState(INITIAL_STATE)
	const dispatch = useCallback(
		(newState: Partial<MenuState>) =>
			setState((prevState) => ({ ...prevState, ...newState })),
		[]
	)

	return (
		<MenuDataStateContext.Provider value={state}>
			<MenuDataDispatchContext.Provider value={dispatch}>
				{children}
			</MenuDataDispatchContext.Provider>
		</MenuDataStateContext.Provider>
	)
}
